import React from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import AppContainer from './modules/app';
import './index.css';
import { GoogleReCaptchaProvider } from '@google-recaptcha/react';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    {/* The site key is a v2 Checkbox key and the signup form renders a
        GoogleReCaptchaCheckbox, so the provider has to agree — declaring
        invisible here loads the API with the wrong parameters. */}
    <GoogleReCaptchaProvider
      type="v2-checkbox"
      siteKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY!}
    >
      <AppContainer />
    </GoogleReCaptchaProvider>
  </React.StrictMode>
);
